// askSmart-ui/src/pages/TOSP/components/LeaseChoiceStep.tsx
import React from "react";
import { LeaseServiceChoice } from "./LeaseReview/leaseSource";

interface LeaseChoiceStepProps {
  /** The leases this contact holds. Only shown when there's more than one. */
  services: LeaseServiceChoice[];
  chosen: string;
  onChoose: (serviceId: string) => void;
  onBack: () => void;
  onClose: () => void;
  onNext: () => void;
}

/**
 * Which of a contact's leases this tenancy is.
 *
 * A person who runs two businesses in the building holds two tenancies, each
 * with its own lease on its own SMRT Docs service. The contact is the same for
 * both and the service names are only a convention, so nothing in the data can
 * answer this — it's asked. The answer is recorded on the tenant, so it's asked
 * once and no later review repeats it.
 */
export default function LeaseChoiceStep({
  services,
  chosen,
  onChoose,
  onBack,
  onClose,
  onNext,
}: LeaseChoiceStepProps) {
  return (
    <>
      <div className="smrtdocs-modal-header tosp-wizard-header">
        <h2 style={{ margin: 0, fontSize: "1rem" }}>Select Lease</h2>
        <button
          type="button"
          className="tosp-wizard-close"
          aria-label="Cancel"
          title="Cancel"
          onClick={onClose}
        >
          ×
        </button>
      </div>

      <div className="smrtdocs-modal-body">
        <div className="tosp-field">
          <label className="tosp-label" htmlFor="tosp-wizard-lease">
            This contact holds {services.length} leases. Which one is this tenancy?
          </label>
          <select
            id="tosp-wizard-lease"
            className="manage-input"
            value={chosen}
            onChange={(e) => onChoose(e.target.value)}
          >
            <option value="">— Select a lease —</option>
            {services.map((service) => (
              <option key={service.serviceId} value={service.serviceId}>
                {service.serviceName}
                {service.documentName ? ` — ${service.documentName}` : ""}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="tosp-wizard-actions">
        <button type="button" className="btn-cancel" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          className="tosp-wizard-next"
          disabled={!chosen}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </>
  );
}
